import React from 'react';
import TimelineEvent from './TimelineEvent';

interface TimelineEventData {
  date: string;
  title: string;
  description: string;
  scripture?: {
    verse: string;
    reference: string;
  };
  iconName: string;
}

const StoryTimeline = () => {
  const timelineEvents: TimelineEventData[] = [
    {
      date: "January 2017",
      title: "Paths Unknowingly Crossed",
      description: "We attended the same high school for a brief season. She was already well acquainted with my sisters, yet somehow we never truly met, or at least, we don’t remember it. Looking back, it feels like God allowed our paths to cross quietly long before we were ready to recognize each other.",
      scripture: {
        verse: "In their hearts humans plan their course, but the Lord establishes their steps",
        reference: "Proverbs 16:9"
      },
      iconName: "SparklesIcon"
    },
    {
      date: "September 2023",
      title: "A new Beginning",
      description: "Years after unknowingly attending the same high school, we crossed paths again, this time, in church. She was serving as an usher. This was when I first noticed her. It wasn’t dramatic or prophetic, just a quiet moment of attention. What felt ordinary at the time was heaven’s subtle beginning. We didn’t recognize destiny then, but God had already written the first line of our story.",
      scripture: {
        verse: "He has made everything beautiful in its time. He has also set eternity in the human heart; yet[a] no one can fathom what God has done from beginning to end.",
        reference: "Ecclesiastes 3:11"
      },
      iconName: "SparklesIcon"
    },
    {
      date: "November 2023",
      title: "Growing in Faith Together",
      description: "I returned to the country and we began attending Phaneroo livestream services at Nyakuron Cultural Center. There was alignment in spirit, shared values. God was drawing our hearts together through shared faith, prayer, and purpose.",
      scripture: {
        verse: "Two are better than one, because they have a good return for their labor",
        reference: "Ecclesiastes 4:9"
      },
      iconName: "BookOpenIcon"
    },
    {
      date: "April 20th 2024",
      title: "The Revelation",
      description: "During Men Gather Season 7, as she served faithfully as an usher and I served in the media department, the Lord placed a clear conviction in my heart: she would be my wife. It wasn’t emotion, it was peace and certainty. What heaven whispered that day, time would later confirm",
      scripture: {
        verse: "The Lord will fulfill His purpose for me",
        reference: "Psalm 138:8"
      },
      iconName: "HeartIcon"
    },
    {
      date: "August 2024",
      title: "The Fish & The Feelings",
      description: "During an official mission to the field, somewhere between shared laughter and our now-famous ‘fish truth serum’ phone conversations, something shifted. I found myself opening up more, speaking more freely, and she began responding with warmth. Friendship was quietly becoming something deeper, and I tell her about how I felt.",
      scripture: {
        verse: "Love is patient, love is kind. It always protects, always trusts, always hopes, always perseveres",
        reference: "1 Corinthians 13:4,7"
      },
      iconName: "GiftIcon"
    },
    {
      date: "October 2024",
      title: "The Defining Conversation",
      description: "We had a serious conversation about timing, purpose, and marriage. I wrestled with my own plans and fears about waiting until I was ready on all aspects. But after leaving, I felt a deep conviction, I couldn’t ignore what God was doing. I chose faith over fear. Love began to mature into intention.",
      scripture: {
        verse: "Trust in the Lord with all your heart and lean not on your own understanding",
        reference: "Proverbs 3:5"
      },
      iconName: "BookOpenIcon"
    },
    {
      date: "Deceber 27, 2024",
      title: "She Said Yes",
      description: "I asked her to be my girlfriend, she said yes. What God had spoken in April was confirmed in December. The ‘yes’ carried the weight of prayer, patience, and growth. It was more than a relationship, it was the beginning of covenant.",
      scripture: {
        verse: "He who finds a wife finds what is good and receives favor from the Lord",
        reference: "Proverbs 18:22"
      },
      iconName: "BookOpenIcon"
    },
    {
      date: "June 2026",
      title: "Families Unite",
      description: "Our families will come together to begin traditional dowry discussions. Honoring our African heritage and inviting wisdom from our elders. This moment represents not just love between two people, but the joining of lineages and legacy",
      iconName: "UsersIcon"
    },
    {
      date: "November 14, 2026",
      title: "Traditional Wedding",
      description: "In celebration of culture and covenant, our traditional wedding will honor our ancestors, families, and community. Songs, blessings, and heritage will mark this sacred union.",
      scripture: {
        verse: "That is why a man leaves his father and mother and is united to his wife, and they become one flesh.",
        reference: "Genesis 2:24 "
      },
      iconName: "UsersIcon"
    },
    {
      date: "November 20, 2026",
      title: "Our Wedding Day",
      description: "We will stand before God, our families, and our community to exchange sacred vows. What began with a quiet spark in 2023 will become a lifelong promise in 2026. A covenant sealed in faith, love, and purpose.",
      scripture: {
        verse: "Therefore what God has joined together, let no one separate",
        reference: "Mark 10:9"
      },
      iconName: "CheckCircleIcon"
    }
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Our Journey Together
          </h2>
          <p className="font-inter text-lg text-muted-foreground max-w-2xl mx-auto">
            Every step of our relationship has been marked by God's faithfulness and perfect timing
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gradient-to-b from-primary via-accent to-secondary" />
          
          {timelineEvents.map((event, index) => (
            <TimelineEvent
              key={index}
              date={event.date}
              title={event.title}
              description={event.description}
              scripture={event.scripture}
              iconName={event.iconName}
              isLeft={index % 2 === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoryTimeline;